import { LoaderDialog } from "@lib/titan2-slingo/dist/game/view/abstract/display/LoaderDialog";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { DestroyUtil } from "@lib/titan2/dist/util/view/DestroyUtil";
import { gsap } from "gsap";
import { PixiPlugin } from "gsap/all";
import { TitanTextResize } from "../../../utils/TitanTextResizer";
import { GameLang } from "../lang/GameLang";
import { ResizeEvent } from "@lib/titan2/dist/game/renderer/Renderer";
gsap.registerPlugin(PixiPlugin);
/**
 * GameLoaderDialog.ts
 */
export class GameLoaderDialog extends LoaderDialog {
    create() {
        super.create();
        if (this.uiProperties.centerTextProperties) {
            this.centerText = TitanTextResize.createField(this, "Center Text", this.landscapeProperties.centerTextProperties, this.portraitProperties?.centerTextProperties);
        }
        if (this.uiProperties.rightTextProperties) {
            this.rightText = TitanTextResize.createField(this, "Right Text", this.landscapeProperties.rightTextProperties, this.portraitProperties?.rightTextProperties);
        }
        if (this.uiProperties.leftTextProperties) {
            this.leftText = TitanTextResize.createField(this, "Left Text", this.landscapeProperties.leftTextProperties, this.portraitProperties?.leftTextProperties);
        }
        if (this.uiProperties.infoFieldFooterProperties) {
            const footer = [GameLang.LOADER_GUIDE_BODY_3_0, GameLang.LOADER_GUIDE_BODY_3_1, GameLang.LOADER_GUIDE_BODY_3_2].map((lang) => this.langManager.getLang(lang));
            this.infoFieldFooter = TitanText.createField(this, this.landscapeProperties.infoFieldFooterProperties, this.portraitProperties?.infoFieldFooterProperties);
            this.infoFieldFooter.setText(`${footer[0]}\n${footer[1]}\n${[footer[2]]}`, true);
            this.infoFieldFooter.name = "infoFieldFooter";
        }
        this.copyright = TitanText.createField(this, this.landscapeProperties.copyrightProperties, this.portraitProperties?.copyrightProperties);
        this.copyright.name = "copyright";
        this.progressBarBackground.addChild(this.progressBar, this.progressBarMask);
        this.handleReinitialiseText();
    }
    destroy() {
        super.destroy();
        DestroyUtil.destroy(this.centerText);
        this.centerText = null;
        DestroyUtil.destroy(this.rightText);
        this.rightText = null;
        DestroyUtil.destroy(this.leftText);
        this.leftText = null;
        DestroyUtil.destroy(this.infoFieldFooter);
        this.infoFieldFooter = null;
        DestroyUtil.destroy(this.copyright);
        this.copyright = null;
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.progressBarMask.position.copyFrom(this.uiProperties.progressBarProperties.position);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(ResizeEvent.REINITIALISE_TEXT, this.handleReinitialiseText);
    }
    handleReinitialiseText() {
        const padding = 80;
        const leftText = this.leftText?.getPixiText();
        const rightText = this.rightText?.getPixiText();
        const centerText = this.centerText?.getPixiText();
        if (leftText)
            leftText.style.padding = padding;
        if (rightText)
            rightText.style.padding = padding;
        if (centerText)
            centerText.style.padding = padding;
    }
    updatePage() { }
    updatePaging() { }
    updateButtons() { }
    createSwipe() { }
}
//# sourceMappingURL=GameLoaderDialog.js.map